import { render } from "./distributionLog.vue?vue&type=template&id=ffba3c2c&scoped=true"
import script from "./distributionLog.vue?vue&type=script&lang=js"
export * from "./distributionLog.vue?vue&type=script&lang=js"

import "./distributionLog.vue?vue&type=style&index=0&id=ffba3c2c&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffba3c2c"]])

export default __exports__